export const PERIOD_TYPE = {
  PERIOD: 'PERIOD',
  MONTH: 'MONTH',
} as const;
